function initSlider () {
    const sliderItems = $('.outcome-phone-slider__slide');
    const slider = $( '.outcome-phone-slider__wrap' );

    if (sliderItems.length > 1) { 

        slider.slick( {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [
                {
                  breakpoint: 720,
                  settings: {
                    dots: true,
                  },
                }
              ],
        });

        slider.on('beforeChange', initNav());
        slider.on('afterChange', scrollToSlideStart);
        $(window).on('scroll', scrollNav);
    }
}

function initNav (e, slick, currentSlide, nextSlide) {
    const progressLine = $('.outcome-phone-slider__progress-line');
    const buttonPrev = $('.slick-prev');
    const items = $('.outcome-phone-slider__slide');
    const progressLineWidth = 100 / items.length;
    progressLine.css('width', progressLineWidth + '%');
    
    if (window.innerWidth < 720) {
        buttonPrev.css('display', 'none');
    }

    return (e, slick, currentSlide, nextSlide, buttonNext, buttonPrev) => {
        if (window.innerWidth >= 720) {
            changeProgressBar(e, slick, currentSlide, nextSlide, progressLineWidth, progressLine);
        } else {
            toogleNav(e, slick, currentSlide, nextSlide);
        }
    }
}

function changeProgressBar (e, slick, currentSlide, nextSlide, progressLineWidth, progressLine) {
    const progressLinePosition = progressLineWidth * nextSlide;
    progressLine.css('left', progressLinePosition + '%');
}

function toogleNav (e, slick, currentSlide, nextSlide) {
    const buttonNext = $('.slick-next');
    const buttonPrev = $('.slick-prev');
    
    if (nextSlide === slick.slideCount - 1) {
        buttonNext.css('display', 'none');
    } else if (!nextSlide) {
        buttonPrev.css('display', 'none');
    } else {
        buttonNext.css('display', 'block');
        buttonPrev.css('display', 'block');
    }
}

function scrollToSlideStart () {
    const slider = $( '.outcome-phone-slider__wrap' );
    const position = slider.offset().top - 70;
    
    $('html, body').animate({
        scrollTop: position,
    }, 500);
}

function scrollNav () {
    const parentBlock = $( '.outcome-phone-slider__wrap' );
	const buttonNext = $( '.slick-next' );
    const buttonPrev = $( '.slick-prev' );
    
    if (window.innerWidth < 720) {
        const windowHeight = window.innerHeight;
		const documentScrollTop = $(document).scrollTop();
		const parentBlockTop = parentBlock.offset().top;
		const parentBlockBottom = parentBlockTop + parentBlock.outerHeight() - buttonNext.height();
		if ( documentScrollTop + windowHeight / 2 > parentBlockTop + parentBlock.outerHeight() / 2 ) {
			buttonNext.css( {position: 'fixed', top: 'calc(50% - 20px)', right: '10px'} );
            buttonPrev.css( {position: 'fixed', top: 'calc(50% - 20px)', left: '10px'} );
		} else {
			buttonNext.css({position: 'absolute', top: 'calc(50% - 20px)', right: '-5px'});
            buttonPrev.css({position: 'absolute', top: 'calc(50% - 20px)', left: '-5px'});
		}
		if ( documentScrollTop > parentBlockBottom - windowHeight / 2 ) {
			buttonNext.css({position: 'absolute', top: 'calc(100% - 20px)', right: '-5px'});
            buttonPrev.css({position: 'absolute', top: 'calc(100% - 20px)', left: '-5px'});
		} 
    }
}

function resizeIframe () {
    const iframe = $(this).find('iframe');
    if (iframe[0]) {
        const height = iframe.attr('height');
        const width = iframe.attr('width');
        const aspectRatio = width / height;
        const innerWidth = iframe.innerWidth();
        iframe.attr('width', Math.round(innerWidth));
        iframe.attr('height', Math.round(innerWidth / aspectRatio));
    }
}

$( document ).ready(function () {
    const sections = $('.section-outcome-phone');
    sections.each(resizeIframe);
    $(window).on('resize', () => sections.each(resizeIframe));
    initSlider();
});